/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userBusinessNotifications.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class Notification(
    @SerialName("id")
    val id: String?,

    @SerialName("type_id")
    val typeId: Int?,

    @SerialName("type")
    val type: String?,

    @SerialName("title")
    val title: String?,

    @SerialName("description")
    val description: String?,

    @SerialName("points")
    val points: Int?,

    @SerialName("amount")
    val amount: Float?,

    @SerialName("hidden")
    val hidden: Boolean?,

    @SerialName("created_at")
    val createdAt: String?
)
